module.exports = __webpack_public_path__ + "static/media/news-coverage.94a31402.png";